/** Preserve GTM's content-sized columns without depending on DLS table internals. */
export function estimateColumnWidth(
  header: string,
  values: string[],
  {
    minWidth = 80,
    maxWidth = 400,
    padding = 32,
  }: { minWidth?: number; maxWidth?: number; padding?: number } = {},
): number {
  return Math.max(
    minWidth,
    Math.min(
      maxWidth,
      values.reduce((longest, value) => Math.max(longest, value.length), header.length) * 8 +
        padding,
    ),
  );
}
